// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","BrandListItem__icon":"vo_a big_ke","BrandListItem__name":"vo_b big_vp"};